document.addEventListener("DOMContentLoaded", function () {
    // £50 off these two boards
    const fiftyPoundOffHandles = [
        "aquaplanet-max-10-6-inflatable-paddle-board-package-glacier-v2",
        "aquaplanet-max-plus-118-inflatable-sup-package-beach"
    ];

    // £30 off all other included paddle boards
    const thirtyPoundOffHandles = [
        // ALLROUND TEN 10' series
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-purple",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-blue",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-orange",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-azure",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-kintsugi",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-cyber",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-spectre",

        // BOLT 9'4" series
        "aquaplanet-bolt-94-inflatable-paddle-board-package-blue",
        "aquaplanet-bolt-94-inflatable-paddle-board-package-coral",

        // ROCKIT 10'2" series
        "aquaplanet-rockit-10-2-inflatable-paddle-board-package-blue",
        "aquaplanet-rockit-10-2-inflatable-paddle-board-package-pink",

        // MAX 10'6" series
        "aquaplanet-max-10-6-inflatable-paddle-board-package-blue",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-orange",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-rainbow",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-prism",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-sunrise",

        // MAX Plus 11'8" series
        "aquaplanet-max-plus-118-inflatable-sup-package-horizon",

        // PACE series
        "aquaplanet-pace-sup-package-stand-up-inflatable-paddle-board-kit-10-6-long-teal-midnight",
        "aquaplanet-pace-sup-package-stand-up-inflatable-paddle-board-kit-10-6-long-red-blue",
        "aquaplanet-pace-118-inflatable-paddle-board-package-nori",
        "aquaplanet-pace-118-inflatable-paddle-board-package-ember",
        "aquaplanet-pace-10-6-inflatable-paddle-board-package-lagoon",
        "aquaplanet-pace-10-6-inflatable-paddle-board-package-coral",

        // Other Aquaplanet paddle boards
        "aquaplanet-seeker-10-8-inflatable-paddle-board-package",
        "aquaplanet-jupiter-116-inflatable-paddle-board-package",
        "aquaplanet-cuda-expedition-14-inflatable-paddle-board-package",
        "aquaplanet-wingtail-9-inflatable-surf-sup-paddle-board-package",
        "aquaplanet-wilderness-adventure-108-inflatable-paddle-board-package",
        "aquaplanet-stinger-explorer-128-inflatable-paddle-board-package",

        // Hurley paddle boards
        "hurley-advantage-terrazzo-10-inflatable-paddle-board-package",
        "hurley-advantage-black-tiger-10-inflatable-paddle-board-package",
        "hurley-advantage-outsider-10-6-inflatable-paddle-board-package",
        "hurley-apextour-malibu-118-inflatable-paddle-board-package",
        "hurley-apextour-freedom-118-inflatable-paddle-board-package"
    ];

    function applyFixedDiscount(priceText, discountAmount) {
        const priceMatch = priceText.replace(/,/g, "").match(/[0-9]+(?:\.[0-9]+)?/);

        if (!priceMatch) {
            return null;
        }

        const price = parseFloat(priceMatch[0]);

        if (isNaN(price)) {
            return null;
        }

        const discountedPrice = Math.max(0, price - discountAmount);
        return `£${discountedPrice.toFixed(2)}`;
    }

    function getDiscountAmount(productHandle) {
        if (fiftyPoundOffHandles.includes(productHandle)) {
            return 50;
        }

        if (thirtyPoundOffHandles.includes(productHandle)) {
            return 30;
        }

        return null;
    }

    function getProductHandle(url) {
        if (!url || !url.includes("/products/")) {
            return null;
        }

        return url
            .split("/products/")
            .pop()
            .split("?")[0]
            .split("#")[0]
            .replace(/\/$/, "");
    }

    function updatePriceElement(priceElement, discountAmount) {
        if (!priceElement || priceElement.dataset.bigSummerSaleApplied === "true") {
            return;
        }

        const discountedPrice = applyFixedDiscount(
            priceElement.textContent,
            discountAmount
        );

        if (!discountedPrice) {
            return;
        }

        priceElement.textContent =
            `${discountedPrice} for Big Summer Sale`;

        priceElement.dataset.bigSummerSaleApplied = "true";
    }

    function updateProductCards() {
        const productCards = document.querySelectorAll(
            ".cl-product-card-inner-container"
        );

        productCards.forEach((card) => {
            const productLink = card.querySelector("a[href*='/products/']");

            if (!productLink) {
                return;
            }

            const productHandle = getProductHandle(
                productLink.getAttribute("href")
            );

            const discountAmount = getDiscountAmount(productHandle);

            if (!discountAmount) {
                return;
            }

            const priceElement = card.querySelector(".price-variation");
            updatePriceElement(priceElement, discountAmount);
        });
    }

    function updateProductPage() {
        const productHandle = getProductHandle(window.location.pathname);
        const discountAmount = getDiscountAmount(productHandle);

        if (!discountAmount) {
            return;
        }

        const priceElements = document.querySelectorAll(
            ".product-details-price-snippet .sale-price, " +
            ".product-form-price .price"
        );

        priceElements.forEach((priceElement) => {
            updatePriceElement(priceElement, discountAmount);
        });
    }

    function updateSummerSalePrices() {
        updateProductCards();
        updateProductPage();
    }

    updateSummerSalePrices();

    // Handles product cards or prices loaded dynamically after page load
    const observer = new MutationObserver(function () {
        updateSummerSalePrices();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});